export default __webpack_public_path__ + "static/media/minimalist-mobile.6d7a5db7.png";